import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Description, Title, Titlespan2 } from '../../components/common/title/index';
import Button from '../../components/common/button';
import { Servicedata, Servicedata1 } from '../../data/service/index';
import Icon from '../../components/common/icon';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import './service.scss';

function renderServiceCard(item) {
  return (
    <div key={item.id} className="service-card">
      <div className="service-icon">
        {item.img ? (
          <img
            src={item.img}
            alt={item.title}
            className="service-icon-img"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = '/assets/images/icons/placeholder.png';
            }}
          />
        ) : item.Icon ? (
          <Icon icon={item.Icon} className="service-icon-fallback" />
        ) : (
          <img
            src="/assets/images/icons/placeholder.png"
            alt={item.title}
            className="service-icon-img"
          />
        )}
      </div>
      <h3>{item.title}</h3>
      <p>{item.content}</p>
    </div>
  );
}

function Service() {
  return (
    <section className="service-wrapper" id="service">
      <Container>
        <Row>
          <Col lg={5} md={4}>
            <div className="service-content-1 main-title-wrapper">
              <Titlespan2
                Class="sitemain-subtitle"
                Name="Why"
                Label="Smart Board Learning?"
              />
              <Title
                Class="service-title"
                Name="Where Music Meets Standards Of Learning!"
              />
              <Description
                Class="service-dec"
                Name="Smart Board Learning turns standards into interactive music, video, and game based challenges that make concepts stick. Students learn by doing tapping, dragging, singing, which boosts attention and retention across different learning styles. Collaborative challenges get kids talking and problem solving together, while real-time feedback personalizes the next step for every learner. Teachers see progress instantly and can adjust on the fly without breaking lesson flow. The result is a classroom that's creative, inclusive, and fun—while staying laser-focused on measurable growth."
              />
              <div className="banner-btn-wrapper">
                <AnchorLink
                  href="#preview"
                  offset={() => (window.innerWidth < 768 ? 100 : 70)}
                >
                  <Button
                    Class="button1 btn button2 gradient-color"
                    Name="LEARN MORE"
                  />
                </AnchorLink>
              </div>
            </div>
          </Col>
          <Col lg={7} md={8} className="service-block-content">
            <Row>
              <Col sm={6} className="service-block1">
                {Servicedata.map(renderServiceCard)}
              </Col>
              <Col sm={6} className="service-block2">
                {Servicedata1.map(renderServiceCard)}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Service;
